import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import axios from 'axios';

const YandexCallback = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { loginWithTokens } = useAuth();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const code = params.get('code');

    if (!code) {
      console.error('Код Яндекс не получен');
      navigate('/login?error=no_code');
      return;
    }

    const verifyYandex = async () => {
      try {
        const response = await axios.post('/api/auth/yandex/verify', { code });
        loginWithTokens(response.data);
        navigate('/profile');
      } catch (err) {
        console.error('Ошибка при верификации Яндекс:', err);
        navigate('/login?error=yandex_failed');
      }
    };

    verifyYandex();
  }, [location, loginWithTokens, navigate]);

  return <div className="min-h-screen flex items-center justify-center">Авторизация через Яндекс...</div>;
};

export default YandexCallback;
